import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { $insertNodeToNearestRoot } from '@lexical/utils';
import { COMMAND_PRIORITY_EDITOR, createCommand, LexicalCommand } from 'lexical';
import { useEffect } from 'react';
import { $createVideoNode, VideoNode } from './VideoNode';
import { Button, TextInput } from '@mantine/core';
import { useState } from 'react';
export const INSERT_VIDEO_COMMAND: LexicalCommand<string> = createCommand('INSERT_VIDEO_COMMAND');

export default function VideoPlugin(): JSX.Element | null {
  const [editor] = useLexicalComposerContext();

  useEffect(() => {
    if (!editor.hasNodes([VideoNode])) {
      throw new Error('VideoPlugin: VideoNode not registered on editor');
    }

    return editor.registerCommand<string>(
      INSERT_VIDEO_COMMAND,
      (payload) => {
        const videoNode = $createVideoNode(payload);
        $insertNodeToNearestRoot(videoNode);

        return true;
      },
      COMMAND_PRIORITY_EDITOR
    );
  }, [editor]);

  return null;
}

export function InsertVideoDialog({ activeEditor, modals }): JSX.Element {
  const [src, setSrc] = useState(null);

  const onClick = () => {
    if (src != null) {
      activeEditor.dispatchCommand(INSERT_VIDEO_COMMAND, src);
      modals.closeAll();
    }
  };

  return (
    <>
      <TextInput
        placeholder="https://www.youtube.com/watch?v=jNQXAC9IVRw"
        value={src}
        onChange={(e) => setSrc(e.currentTarget.value)}
        mb="md"
      />
      <Button disabled={!src} onClick={onClick}>
        Embed
      </Button>
    </>
  );
}
